import React, { Component} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Table, {
    TableRow,
    TableCell
} from "@amzn/meridian/table";
import Loader from "@amzn/meridian/loader";
import Link from "@amzn/meridian/link";
import {getPackageHistoryForParentContainer} from "../../../commons/api/GetPackageHistoryForParentContainerResults.js";
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import chevronRightLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-right-large";
import Icon from "@amzn/meridian/icon";
import Toaster from "@amzn/meridian/toaster";
import Alert from "@amzn/meridian/alert";
import {batchGetPackageSummaryForPackageId} from "../../../commons/api/BatchGetPackageSummaryResults.js";
import { validateEmail, oldTimeZoneMapper, handleBlankValue } from "../../../commons/CommonUtils.js";
import { FormattedMessage, injectIntl } from "react-intl";

class PackageView extends Component {

    constructor(props) {
        super(props)
        this.state = {
          isLoading : true,
          previousPageTokens: [null],
          nextPageToken: null,
          toasters: []
        }
        this.setUpdated = props.setUpdated.bind(this)
    }

    getPageSize() {
        return 100
    }

    searchPath = "#" + this.props.previousPath + "/";

    searchAssociateRequestOption = {
        "type": "ASSOCIATE",
        "startDate": this.props.startDate,
        "endDate": this.props.endDate
    }

    fetchAssociate = (lastProcessedByAssociateName) => {
        return lastProcessedByAssociateName ?
        (validateEmail(lastProcessedByAssociateName) ? 
        (<Link href = {this.searchPath.concat(lastProcessedByAssociateName).concat("/" + JSON.stringify(this.searchAssociateRequestOption))}>{lastProcessedByAssociateName}</Link>)
        : lastProcessedByAssociateName
        )
        : '';
    }

    async nextButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });
        if (this.state.packageHistory.length < this.getPageSize()) {
            this.setState({
                isLoading: false,
                toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
            });
        } else {

            let packageHistoryData = await getPackageHistoryForParentContainer(this.props.parentContainerLabel,
                this.props.nodeId, this.getPageSize(), this.state.nextPageToken, this.props.startDate, this.props.endDate);
            this.setUpdated({})

            let packageIdList = packageHistoryData.packageHistory.map(packageHistoryElement => {
                return packageHistoryElement.trackingId;
            });
            
            let packageRecentDataList = [];
            if (packageIdList.length > 0) {
                packageRecentDataList = await batchGetPackageSummaryForPackageId(packageIdList);
            }

            if (packageHistoryData.packageHistory.length > 0) {
                this.setState({
                    isLoading: false,
                    previousPageTokens: this.state.previousPageTokens.concat([this.state.nextPageToken]),
                    packageHistory : packageHistoryData.packageHistory,
                    nextPageToken : packageHistoryData.nextPageToken,
                    packageLatestInfoList : packageRecentDataList
                });
            } else {
                this.setState({
                    isLoading: false,
                    toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_next_entry'}), timeout: 3000}]
                });
            }
        }
    }

    async previousButtonClick() {
        this.setState({
            isLoading : true,
            toasters: []
        });

        let newPreviousPageTokens = this.state.previousPageTokens.slice(0, -1);
        let prevPageToken = newPreviousPageTokens.slice(-1).pop();

        let packageHistoryData = await getPackageHistoryForParentContainer(this.props.parentContainerLabel,
            this.props.nodeId, this.getPageSize(), prevPageToken, this.props.startDate, this.props.endDate);
        this.setUpdated({})

        let packageIdList = packageHistoryData.packageHistory.map(packageHistoryElement => {
            return packageHistoryElement.trackingId;
        });

        let packageRecentDataList = [];
        if (packageIdList.length > 0) {
            packageRecentDataList = await batchGetPackageSummaryForPackageId(packageIdList);
        }

        if (packageHistoryData.packageHistory.length > 0) {
           this.setState({
               isLoading: false,
               previousPageTokens: newPreviousPageTokens,
               packageHistory : packageHistoryData.packageHistory,
               nextPageToken : packageHistoryData.nextPageToken,
               packageLatestInfoList : packageRecentDataList
            });
            
        } else {
           this.setState({
               isLoading: false,
               toasters: [{ id: this.props.intl.formatMessage({id: 'search.no_previous_entry'}), timeout: 3000}]
            });
       }
    }

    async componentDidMount() {
        let packageHistoryData = await getPackageHistoryForParentContainer(this.props.parentContainerLabel,
            this.props.nodeId, this.getPageSize(), null, this.props.startDate, this.props.endDate);
        this.setUpdated({})

        let packageIdList = packageHistoryData.packageHistory.map(packageHistoryElement => {
            return packageHistoryElement.trackingId;
        });
        
        let packageRecentDataList = [];
        if (packageIdList.length > 0) {
            packageRecentDataList = await batchGetPackageSummaryForPackageId(packageIdList);
        }

        this.setState({
            isLoading : false,
            packageHistory : packageHistoryData.packageHistory,
            nextPageToken : packageHistoryData.nextPageToken,
            previousPageToken : this.state.previousPageTokens.concat([this.state.nextPageToken]),
            packageLatestInfoList : packageRecentDataList
        })
    }


    sentenceCase (str) {
        if ((str===null) || (str===''))
             return null;
        else
         str = str.toString();
        return str.toLowerCase().replace(/_/g," ").replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    }

    render() {
        return this.state.isLoading ? <Row spacingInset="large" widths={["grid-2"]}><Column/><Loader/></Row> : this.renderHistoryTable();
    }

    renderHistoryTable() {
        return (
            <React.Fragment>
                <Toaster toasts={this.state.toasters} onCloseToast={() => {this.setState({toasters: []})}} alignmentHorizontal="center">
                    {(toast) => <Alert toast={true}>{toast.id}</Alert>}
                </Toaster>
                <Column spacingInline="large large none large">
                    <Row widths={["grid-12"]} spacingInset="none">
                        <div style={{"overflowX": "scroll"}}>
                            <Table showDividers={false} spacing="small">
                            <TableRow>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_trackingId" defaultMessage="Tracking Id"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_currentStatus" defaultMessage="Current Status"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_currentReason" defaultMessage="Current Reason"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_lastUpdated" defaultMessage="Last Updated"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_lastProcessedBy" defaultMessage="Last Processed By"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_eventStatus" defaultMessage="Event Status"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_eventReason" defaultMessage="Event Reason"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_eventTime" defaultMessage="Event Time"/></Text></TableCell>
                                <TableCell width={160}><Text type="h100"><FormattedMessage id="search.container.packageview_eventProcessedBy" defaultMessage="Event Processed By"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_station" defaultMessage="Station"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_sortZone" defaultMessage="Sort Zone"/></Text></TableCell>
                                <TableCell width={150}><Text type="h100"><FormattedMessage id="search.container.packageview_route" defaultMessage="Route"/></Text></TableCell>
                            </TableRow>
                            {   this.state.packageHistory && this.state.packageHistory.map((history, index) => {
                                let searchPath = "#/detailPage/";
                                let dateOption = {timeZone: this.props.stationTimeZone ? oldTimeZoneMapper(this.props.stationTimeZone) : undefined};
                                let dateAdded = new Date(history.dateAdded).toLocaleString('en-US', dateOption);
                                let latestInfo = this.state.packageLatestInfoList.find(currentPackage => currentPackage.trackingId === history.trackingId);
                                let currentStatus = latestInfo ? latestInfo.currentPackageState : null;
                                let currentReason = latestInfo ? latestInfo.reasonCode : null;
                                let lastUpdatedTime = latestInfo ? new Date(latestInfo.lastUpdatedTime).toLocaleString('en-US', dateOption) : null;
                                let lastProcessedByAssociateName = latestInfo ? latestInfo.lastProcessedByAssociateName : null;                              
                                return <TableRow>   
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} ><Link href = {searchPath.concat(history.trackingId)}>{history.trackingId}</Link></div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.sentenceCase(currentStatus))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.sentenceCase(currentReason))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(lastUpdatedTime)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{this.fetchAssociate(handleBlankValue(lastProcessedByAssociateName))}</div></TableCell>                              
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.sentenceCase(history.packageState))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(this.sentenceCase(history.reasonCode))}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(dateAdded)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{this.fetchAssociate(handleBlankValue(history.addedByAssociateName))}</div></TableCell>                              
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.nodeId)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.sortZone)}</div></TableCell>
                                <TableCell alignmentVertical="top"><div style={{"whiteSpace": "nowrap"}} >{handleBlankValue(history.routeCode)}</div></TableCell>
                            </TableRow>   
                            })}  
                            </Table>
                        </div>
                    </Row>
                    <Row widths={["grid-6", "grid-6"]} spacingInset="none">
                        <Button type="link" onClick={this.previousButtonClick.bind(this)} disabled={this.state.previousPageTokens.length <= 1}><Icon tokens={chevronLeftLargeTokens} /></Button>
                        <Button type="link" onClick={this.nextButtonClick.bind(this)}><Icon tokens={chevronRightLargeTokens} /></Button>
                    </Row>  
                </Column> 
            </React.Fragment>       
        )
    }
}




export default injectIntl(PackageView);




// WEBPACK FOOTER //
// ./src/components/detailPages/containerDetails/PackageView.js